import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  withStyles,
  Checkbox,
  Fade,
  Popover,
  List,
  ListItem
} from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import { PAGE_SIZE_LIST } from 'src/app/constant/config';
import { useQuery } from 'src/app/hooks/useQuery';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import DialogConfirm from 'src/app/components/DialogConfirm';
import { MESSAGE } from 'src/app/constant/message';
import { closeDialogConfirm, showDialogConfirm } from 'src/features/uiSlice';
import { useDispatch } from 'react-redux';
import { deleteSafeZone } from 'src/features/safeZoneSlice';
import EditSafeZone from './EditSafeZone';
import { useNavigate } from 'react-router';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    whiteSpace: 'nowrap'
  },
  body: {
    fontSize: 14,
    whiteSpace: 'nowrap'
  },
  root: {
    padding: '12px 16px'
  }
}))(TableCell);

const Results = ({
  className,
  totalSafeZones,
  listSafeZones,
  getListCustomerRef,
  currentParams
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [limit, setLimit] = useState(PAGE_SIZE_LIST);
  const [page, setPage] = useState(1);
  const [rowsSelected, setRowsSelected] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [itemCurrent, setItemCurrent] = useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [params, setParams] = useState({
    page: page,
    page_size: limit
  });
  const dispatch = useDispatch();
  const query = useQuery();

  useEffect(() => {
    if (currentParams) {
      setParams({
        ...currentParams,
        page: currentParams?.page || 1,
        page_size: currentParams?.page_size || PAGE_SIZE_LIST
      });
    }
  }, [currentParams]);

  useEffect(() => {
    const pageFromQuery = query.get('page');
    const pageSizeFromQuery = query.get('page_size');

    if (pageFromQuery) {
      setParams(prev => ({
        ...prev,
        page: Number(pageFromQuery)
      }));
    }
    if (pageSizeFromQuery) {
      setParams(prev => ({
        ...prev,
        page_size: Number(pageSizeFromQuery)
      }));
    }
  }, [query]);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    if (!getListCustomerRef) return;
    const newParams = {
      ...currentParams,
      page: newPage,
      page_size: limit
    };
    setParams(newParams);
    getListCustomerRef(newParams);
  };

  const checked = id => {
    return rowsSelected.indexOf(id) !== -1;
  };

  const select = id => {
    if (rowsSelected.indexOf(id) === -1) {
      const newSelected = [id, ...rowsSelected];
      setRowsSelected(newSelected);
    } else {
      const newSelected = rowsSelected.filter(i => i !== id);
      setRowsSelected(newSelected);
    }
  };

  const checkAll = () => {
    if (rowsSelected.length > 0) {
      setRowsSelected([]);
    }

    if (
      listSafeZones.length > 0 &&
      rowsSelected.length !== listSafeZones.length
    ) {
      const all = listSafeZones.map(item => {
        return item.id;
      });
      setRowsSelected(all);
    }
  };

  const handleClickMenu = (event, safeZone) => {
    setAnchorEl(event.currentTarget);
    setItemCurrent(safeZone);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleDeleteSafeZone = () => {
    dispatch(showDialogConfirm());
    handleCloseMenu();
  };

  const handleEditSafeZone = () => {
    setOpenEditModal(true);
    handleCloseMenu();
  };

  const confirmDelete = () => {
    setRowsSelected([]);
    dispatch(closeDialogConfirm());
    dispatch(deleteSafeZone({ id: itemCurrent.id }));
  };

  const closeEditModal = () => {
    setOpenEditModal(false);
    setItemCurrent(null);
  };

  const handleViewSafeZoneMap = () => {
    const { lat, long, radius } = itemCurrent;
    navigate(`/app/tracking?lat=${lat}&lng=${long}&zoomTo=true&radius=${radius}`);
  }
  const open = Boolean(anchorEl);

  return (
    <>
      <DialogConfirm
        title={MESSAGE.CONFIRM_DELETE_SAFE_ZONE}
        textOk={MESSAGE.BTN_YES}
        textCancel={MESSAGE.BTN_CANCEL}
        content={MESSAGE.CONTENT_DELETE_SAFE_ZONE}
        callbackOk={() => confirmDelete()}
        callbackCancel={() => dispatch(closeDialogConfirm())}
      />
      {openEditModal && (
        <EditSafeZone
          open={openEditModal}
          onClose={closeEditModal}
          safeZoneData={itemCurrent}
        />
      )}
      <Card className={clsx(classes.root, className)}>
        <div>
          {rowsSelected.length > 0 && (
            <Fade in={rowsSelected.length > 0}>
              <Box
                minWidth={1050}
                style={{ fontSize: '14px', padding: '12px 16px' }}
              >
                <span>
                  <Checkbox
                    checked={rowsSelected.length > 0}
                    onChange={() => checkAll()}
                    color="primary"
                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                  />
                </span>

                {/* <span
                  className="mx-2 btnDevice"
                  color="primary"
                  variant="outlined"
                  size="small"
                >
                  <img
                    src={`/static/iconSvg/delete-icon.svg`}
                    alt="delete"
                    style={{ paddingRight: '5px', paddingBottom: '4px' }}
                  />
                  <span className="pt-1"> Xóa </span>
                </span> */}
              </Box>
            </Fade>
          )}
          <PerfectScrollbar>
            {listSafeZones && listSafeZones.length ? (
              <Box minWidth={1050}>
                <Table>
                  {listSafeZones?.length > 0 && rowsSelected.length === 0 && (
                    <TableHead>
                      <TableRow>
                        <StyledTableCell style={{ width: '5%' }}>
                          <Checkbox
                            checked={rowsSelected.length > 0}
                            onChange={() => checkAll()}
                            color="primary"
                            inputProps={{
                              'aria-label': 'secondary checkbox'
                            }}
                          />
                        </StyledTableCell>
                        <StyledTableCell style={{ width: '30%' }}>
                          Tên vùng giám sát
                        </StyledTableCell>
                        <StyledTableCell style={{ width: '40%' }}>
                          Địa chỉ
                        </StyledTableCell>
                        <StyledTableCell style={{ width: '15%' }}>
                          Bán kính (m)
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ width: '10%' }}
                        ></StyledTableCell>
                      </TableRow>
                    </TableHead>
                  )}
                  <TableBody>
                    {listSafeZones.map(safeZone => (
                      <TableRow hover key={safeZone.id}>
                        <StyledTableCell
                          style={{ maxWidth: '30px' }}
                          onClick={() => select(safeZone?.id)}
                        >
                          <Checkbox
                            checked={checked(safeZone?.id)}
                            onChange={() => select(safeZone?.id)}
                            color="primary"
                            inputProps={{
                              'aria-label': 'secondary checkbox'
                            }}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          {safeZone?.nameSafeZone || '-'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {safeZone?.address || '-'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {safeZone?.radius || '-'}
                        </StyledTableCell>
                        <StyledTableCell>
                          <span style={{ color: '#AEB1C5' }}>
                            <MoreVertIcon
                              aria-describedby={`menu-safezone-${safeZone.id}`}
                              className={`cursor-pointer hover-red`}
                              onClick={e => handleClickMenu(e, safeZone)}
                            />
                          </span>

                          <Popover
                            id={`menu-safezone-${safeZone.id}`}
                            className="popover-device"
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleCloseMenu}
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'left'
                            }}
                            transformOrigin={{
                              vertical: 'top',
                              horizontal: 'right'
                            }}
                          >
                            <Typography>
                              <List>
                                <ListItem
                                  className="border-bottom list-menu-device cursor-pointer"
                                  onClick={handleViewSafeZoneMap}
                                >
                                  Tới vị trí trên bản đồ
                                </ListItem>
                                <ListItem
                                  className="border-bottom list-menu-device cursor-pointer"
                                  onClick={handleEditSafeZone}
                                >
                                  Chỉnh sửa
                                </ListItem>
                                <ListItem
                                  className="cursor-pointer list-menu-device"
                                  onClick={handleDeleteSafeZone}
                                >
                                  <span className="text-danger"> Xóa </span>
                                </ListItem>
                              </List>
                            </Typography>
                          </Popover>
                        </StyledTableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            ) : (
              <div className="text-center pb-5">
                <img src="/static/empty.png" class="justify-content-center" />
                <h4> Danh sách trống </h4>
              </div>
            )}
          </PerfectScrollbar>
        </div>
      </Card>
      {listSafeZones && listSafeZones.length > 0 && (
        <div class="mt-3 mr-4 float-right">
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '15px'
            }}
          >
            <Typography style={{ fontSize: '14px' }}>
              Tổng: {totalSafeZones}
            </Typography>
            <Pagination
              count={Math.ceil(totalSafeZones / limit)}
              color="primary"
              size="small"
              onChange={handlePageChange}
              page={Number(params.page)}
              showFirstButton
              showLastButton
            />
          </Box>
        </div>
      )}
    </>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  listAgencies: PropTypes.array.isRequired
};

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    '&.MuiPaper-elevation1': {
      boxShadow: 'none'
    }
  },
  groupAction: {
    display: 'flex',
    alignItems: 'center',
    '& .action': {
      cursor: 'pointer',
      padding: '0 5px',
      '&:hover': {
        color: '#3f51b5'
      }
    }
  },
  minWithColumn: {
    minWidth: '150px'
  }
}));

export default React.memo(Results);
